import {Inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";

export class EntityImportStatusAction {
    constructor(public id: string) {
    }
}

export class EntityImportStatusActionResp {
    status: ImportStatus;
    percentageComplete: number;

    /**
     * Map of statuses indexed by ref ids. The ref ids are passed in with the records in the request
     */
    trackedRefs: any;
}

export enum ImportStatus {
    WAITING = <any>"waiting",
    PROCESSING = <any>"processing",
    COMPLETE = <any>"complete",
    FAILED = <any>"failed"
}

/**
 * Action Service to import entities
 */
@Injectable()
export class EntityImportStatusService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "entity-import-status");
    }
}
